module.exports = __webpack_public_path__ + "static/media/arrow-right.1842eea6.svg";